import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12">
          {t('about.title')}
        </h2>
        <div className="bg-white rounded-xl p-10 shadow-lg">
          <p className="text-base text-gray-700 leading-relaxed text-center">
            {t('about.description')}
          </p>
        </div>
      </div>
    </section>
  );
}